import { render } from "./Detail_article.vue?vue&type=template&id=6658071c&scoped=true"
import script from "./Detail_article.vue?vue&type=script&lang=js"
export * from "./Detail_article.vue?vue&type=script&lang=js"

import "./Detail_article.vue?vue&type=style&index=0&id=6658071c&scoped=true&lang=css"

import exportComponent from "D:\\Developpement\\HATPLC\\frontend 25122025\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6658071c"]])

export default __exports__